/**
 * Loan product types lenders can opt into supporting on the LoanKnow
 * marketplace. Used by the lender signup form on the public /lenders page.
 */
export const LENDER_PRODUCT_TYPES = [
  {
    code: 'conv',
    name: 'Conventional',
    description: 'Conforming, high-balance, jumbo (Fannie Mae / Freddie Mac)',
  },
  {
    code: 'fha',
    name: 'FHA',
    description: 'Government-insured loans for first-time and credit-challenged buyers',
  },
  {
    code: 'va',
    name: 'VA',
    description: 'Veterans Affairs loans for active-duty, veterans, and eligible spouses',
  },
  {
    code: 'usda',
    name: 'USDA',
    description: 'Rural Development loans for eligible properties and incomes',
  },
  {
    code: 'nonqm',
    name: 'Non-QM',
    description: 'Bank statement, DSCR, asset depletion, ITIN, and other alt-doc programs',
  },
];

export const LENDER_CHANNELS = [
  { code: 'retail', name: 'Retail' },
  { code: 'wholesale', name: 'Wholesale / Broker' },
  { code: 'correspondent', name: 'Correspondent' },
];

export const VOLUME_BUCKETS = [
  { code: '<10',     label: 'Under 10 / month' },
  { code: '10-50',   label: '10 – 50 / month' },
  { code: '50-200',  label: '50 – 200 / month' },
  { code: '200+',    label: '200+ / month' },
];

export default LENDER_PRODUCT_TYPES;
